import { useQuery } from '@tanstack/react-query'
import { useId } from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { useI18n } from '@/lib/i18n'
import { useTRPC } from '@/lib/trpc'

export function JevRoutingStatus() {
  const trpc = useTRPC()
  const id = useId()
  const { t } = useI18n()
  const query = useQuery({
    ...trpc.queryRouter.getJevRouting.queryOptions(),
    staleTime: 0,
    refetchInterval: 10_000,
    refetchOnWindowFocus: 'always',
    retry: 1,
  })
  const known = query.data !== undefined && !query.isError

  return (
    <div className="ms-7 flex items-start gap-3" data-testid="jev-routing-status">
      {known
        ? (
            <Checkbox
              id={id}
              checked={query.data?.enabled === true}
              disabled
              className="mt-0.5 disabled:cursor-default disabled:opacity-100"
              data-testid="jev-routing-enabled"
            />
          )
        : <span aria-hidden="true" className="mt-0.5 size-4 shrink-0 rounded-sm bg-muted" />}
      <div className="min-w-0 space-y-1">
        <Label htmlFor={known ? id : undefined} className="text-sm font-normal text-muted-foreground">
          {t('game.jevEnabled')}
        </Label>
        {!known && (
          <div role={query.isError ? 'alert' : 'status'} className="text-xs text-muted-foreground">
            {query.isError ? t('game.jevStatusUnavailable') : t('game.jevStatusLoading')}
            {query.isError && (
              <button
                type="button"
                onClick={() => { void query.refetch() }}
                disabled={query.isFetching}
                className="ms-2 inline-flex min-h-6 items-center underline underline-offset-4 focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50"
              >
                {t('game.jevStatusRetry')}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
